import { defineComponent as c, computed as o, openBlock as d, createBlock as n, unref as r, normalizeClass as s, withCtx as m, createCommentVNode as v, renderSlot as g } from "vue";
import { RevButtonBase as y } from "@ds/components/ButtonBase";
import { RevSpinner as h } from "@ds/components/Spinner";
import { tw as a } from "../../utils/tailwind.js";
const x = /* @__PURE__ */ c({
  name: "RevButtonCard",
  __name: "ButtonCard",
  props: {
    ariaDescribedby: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    ariaLabel: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    loadingAlternativeText: { default: void 0 },
    to: { default: void 0 },
    tracking: { default: () => ({}) }
  },
  emits: ["click"],
  setup(e) {
    const l = e, u = o(() => [
      a`shadow-short rounded-lg relative block no-underline motion-safe:transition motion-safe:duration-200 motion-safe:ease-in`,
      l.disabled ? a`bg-float-default-low-disabled cursor-not-allowed saturate-0` : a`bg-float-default-low focus-visible-outline-default-hi cursor-pointer hover:bg-float-default-low-hover hover:shadow-long`,
      l.disabled && !l.loading && a`[&>*]:opacity-70`,
      l.loading && a`overflow-hidden [&>*:not(:first-child)]:invisible`
    ]), f = o(() => [
      a`absolute left-0 top-1/2 -mt-12 w-full`,
      l.disabled ? a`text-action-default-hi-disabled` : a`text-action-default-hi`
    ]);
    return (t, i) => (d(), n(r(y), {
      "aria-describedby": e.ariaDescribedby,
      "aria-label": e.loading ? e.loadingAlternativeText : e.ariaLabel,
      "aria-labelledby": e.ariaLabelledby,
      class: s(u.value),
      disabled: e.disabled,
      to: e.to,
      tracking: e.tracking,
      onClick: i[0] || (i[0] = (b) => t.$emit("click", b))
    }, {
      default: m(() => [
        e.loading ? (d(), n(r(h), {
          key: 0,
          "alternative-text": "",
          class: s(f.value)
        }, null, 8, ["class"])) : v("", !0),
        g(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["aria-describedby", "aria-label", "aria-labelledby", "class", "disabled", "to", "tracking"]));
  }
});
export {
  x as default
};
